import { useState } from 'react';

import { useSessionState } from '@utils/storage';
import { UnpaidOrdersNotifyContainer } from '@containers/UnpaidOrdersNotify';
import { ProductAvailabilityFeedbackContainer } from '@containers/ProductAvailabilityFeedback';
import { indexActionBannerKey } from '@constants';

import s from './IndexActionBannerController.sss';

type BannerType = 'unpaidOrders' | 'productAvailabilityFeedback' | 'none';

export const IndexActionBannerController: React.FC = () => {
  const [sessionBanner, setSessionBanner] = useSessionState<BannerType | undefined>(
    indexActionBannerKey,
  );
  const [currentBanner, setCurrentBanner] = useState<BannerType>(sessionBanner || 'unpaidOrders');

  if (currentBanner === 'unpaidOrders') {
    return (
      <UnpaidOrdersNotifyContainer
        className={s.root}
        onInitialLoad={
        ({ isEmptyResult }) => {
          if (isEmptyResult) {
            // If result empty move to next banner
            setCurrentBanner('productAvailabilityFeedback');
          } else {
            // Otherwise make this banner as session banner
            // and use it for next renders
            setSessionBanner('unpaidOrders');
          }
        }
      }
      />
    );
  }

  if (currentBanner === 'productAvailabilityFeedback') {
    return (
      <ProductAvailabilityFeedbackContainer
        className={s.root}
        onInitialLoad={
        ({ isEmptyResult }) => {
          if (isEmptyResult) {
            // If result empty set empty banner
            setCurrentBanner('none');
            setSessionBanner('none');
          } else {
            // Otherwise make this banner as session banner
            // and use it for next renders
            setSessionBanner('productAvailabilityFeedback');
          }
        }
      }
      />
    );
  }

  return null;
};